// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2869":"1e8629f7","4487":"1e8629f7","5725":"1e8629f7"}[chunkId] + ".chunk.css";
};